import * as types from './actionTypes';
import axios from 'axios';
import {getHeader} from '../helper';

function getCamerasRequest() {
    return {
        type: types.GET_CAMERAS_REQUEST
    }
}

function getCamerasReceive(data) {
    return {
        type: types.GET_CAMERAS_SUCCESS,
        data: data
    }
}

function getCameraByIdReceive(data) {
    return {
        type: types.GET_CAMERA_BY_ID_SUCCESS,
        data: data
    }
}

function getCamerasError(messages) {
    return {
        type: types.GET_CAMERAS_FAILURE,
        messages
    }
}

export function getCameras(args, callback) {

    let id= args.id ? args.id + '/' : '';
    let defaultSettings = {
        url: `${window.siteUrl}/api/v1/camera_requirement/${id}`,
        params: {},
        headers: getHeader(),
    }

    let newSettings = Object.assign({}, defaultSettings, args, {
        params: {
            ...defaultSettings.params,
            ...args.params
        }
    });
    
    return function (dispatch) {
        dispatch(getCamerasRequest())

        return axios.get(newSettings.url, {
            params: newSettings.params,
            headers: newSettings.headers
        })
        .then(function (response) {
            if(id !== '') {
                dispatch(getCameraByIdReceive(response.data));
            }
            else{
                dispatch(getCamerasReceive(response.data));
            }
            
            if(callback) callback(response.data);
        })
        .catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("load cameras error-", err.data, err.status, err.headers);
                dispatch(getCamerasError(err.data));
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/cameraRequirementActions.js